"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BellOn = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_BellOn_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.995 1.098a1 1 0 1 0-1.99 0C4.652 1.57 2.873 3.68 2.873 6.204a5.942 5.942 0 0 1-1.698 4.169l-.27.273a1.883 1.883 0 0 0-.587 1.39c0 1.082.87 1.964 1.935 1.964H6a2 2 0 1 0 4 0h3.748c1.065 0 1.934-.882 1.934-1.963 0-.533-.206-1.036-.587-1.39l-.27-.274a5.942 5.942 0 0 1-1.697-4.17c0-2.524-1.78-4.633-4.133-5.105Zm-7.377 10.25.27-.273a6.942 6.942 0 0 0 1.985-4.871C3.873 3.872 5.738 2 8 2c2.262 0 4.128 1.872 4.128 4.204 0 1.82.709 3.575 1.985 4.87l.27.274.031.03a.885.885 0 0 1 .268.659.953.953 0 0 1-.934.963H2.253c-.5 0-.935-.42-.935-.963a.884.884 0 0 1 .3-.689ZM8 15a1 1 0 0 1-1-1h2a1 1 0 0 1-1 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_BellOn_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = BellOn;
exports["default"] = _default;